import RegularButton from "components/CustomButtons/Button";
import React, { useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import FileCopyIcon from "@material-ui/icons/FileCopy";

export const CodeComponent = ({ height, code, color, color2 }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const customStyle = {
    backgroundColor: color,
    fontSize: "14px",
    color: "red",
    ".token.operator, .token.punctuation": {
      backgroundColor: "transparent !important",
    },
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setCopySuccess(true);
        setTimeout(() => {
          setCopySuccess(false);
        }, 1500);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div
      style={{
        overflow: "hidden",
        overflowY: "scroll",
        borderRadius: 16,
        position: "relative",
      }}
    >
      <SyntaxHighlighter
        language="javascript"
        customStyle={{ ...customStyle, height }}
      >
        {code}
      </SyntaxHighlighter>
      <RegularButton
        round
        justIcon
        color="transparent"
        size="sm"
        tooltip={copySuccess ? "Copiado" : "Copiar"}
        onClick={handleCopy}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <FileCopyIcon style={{ color: color2 }} />
      </RegularButton>
    </div>
  );
};
